module.exports = __webpack_public_path__ + "static/img/richman_a.1f4aeac.png";


//////////////////
// WEBPACK FOOTER
// ./static/richman_a.png
// module id = 4sD2
// module chunks = 0